<template>
  <v-layout class="pl-form" :disabled="isDisabled">
    <v-expansion-panel :value="expand" class="pl-expansion-panel pl-expansion-panel_margin_top">
      <form-content :disabled="isDisabled" @switch="opened = !opened">
        <div slot="header">
          <slot name="header-icon" />
          {{ title }}
          <slot name="header" />
        </div>

        <v-divider />

        <v-card flat>
          <v-card-text>
            <slot> </slot>
          </v-card-text>
        </v-card>
      </form-content>
    </v-expansion-panel>
  </v-layout>
</template>

<script>
import FormContent from './FormContent'

export default {
  name: 'Form',
  components: {
    'form-content': FormContent,
  },
  props: {
    title: {
      type: String,
    },
    expand: {
      type: Number,
      default: 0,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      opened: true,
    }
  },
}
</script>
